import React, { useState } from 'react';
import HeaderConnectionImage from '../Headers/HeaderConnectionImage';

/**
 * HeaderConnectionImageShowcase - Demonstrates the HeaderConnectionImage component
 */
const HeaderConnectionImageShowcase = () => {
  const [editableName, setEditableName] = useState('John Smith');
  
  const handleBackClick = () => {
    alert('Back button clicked!');
  };

  const showcaseStyle = {
    marginBottom: '20px'
  };
  
  // Example variants
  const headerExamples = [
    {
      title: 'Basic Header with Name and Image',
      props: {
        name: 'Mark Mangan',
        imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        showBackButton: true,
        onBackClick: handleBackClick
      }
    },
    {
      title: 'Header with Initial Letter (No Image)',
      props: {
        name: 'Mark Mangan',
        initialLetter: 'M',
        showBackButton: true,
        onBackClick: handleBackClick
      }
    },
    {
      title: 'Header with Editable Name',
      props: {
        name: editableName,
        imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        onNameChange: (e) => setEditableName(e.target.value),
        isEditable: true,
        showBackButton: true,
        onBackClick: handleBackClick
      }
    },
    {
      title: 'Header with Phone and Email Contact',
      props: {
        name: 'Jane Doe',
        imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        showBackButton: true,
        onBackClick: handleBackClick,
        contactInfo: { 
          phone: '123-456-7890',
          email: 'jane@example.com'
        }
      }
    },
    {
      title: 'Header with All Contact Types',
      props: {
        name: 'Alex Johnson',
        initialLetter: 'A',
        showBackButton: true,
        onBackClick: handleBackClick,
        contactInfo: {
          phone: '123-456-7890',
          email: 'alex@example.com',
          instagram: 'alexj'
        }
      }
    },
    {
      title: 'Header with Long Name',
      props: {
        name: 'Christopher Alexander Bartholomew Williamson III',
        imageUrl: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
        showBackButton: true,
        onBackClick: handleBackClick,
        contactInfo: { email: 'christopher@example.com' }
      }
    }
  ];

  return (
    <div>
      {headerExamples.map((example, index) => (
        <div key={index} style={showcaseStyle}>
          <h3>{`${index + 1}. ${example.title}`}</h3>
          <HeaderConnectionImage {...example.props} />
        </div>
      ))}
    </div>
  );
};

export default HeaderConnectionImageShowcase;
